import Image from '../../../../../../app/shared/components/Image/Image';
import Link from '../../../../../../app/shared/components/Link';
import css from './ProductThumbnail.css';
import ProductThumbnailState from './ProductThumbnailState';
import ProductVariationList from './ProductVariationList/ProductVariationList';

interface ProductThumbnailProps {
  state: ProductThumbnailState;
  onClick?: () => void;
}

const ProductThumbnail = ({ state, onClick }: ProductThumbnailProps) => {
  return (
    <article className={css.container}>
      <h3 className={css.name}>
        <Link to={state.linkUrl} className={css.link} onClick={onClick}>
          {state.product.name}
        </Link>
      </h3>
      <Image className={css.image} src={state.imageSrc} width={295} height={350} size="contain" />
      <span className={css.price}>{state.formattedLowestPrice}</span>
      <ProductVariationList
        className={css.variants}
        items={state.variations}
        translation={state.translation.productThumbnail.productVariationList}
      />
    </article>
  );
};

export default ProductThumbnail;
